// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_l1-5";
export var filledCircle = "_l1-4";
export var historyEntry = "_l1-3";
export var messageSideLeft = "_l1-1";
export var messageSideRight = "_l1-2";
export var orderTrackingCarouselWrapper = "_l1-6";
export var orderTrackingInfoContainer = "_l1-0";